<template>
  <div class="transaction-layout-budget-block">
    <div class="transaction-layout-budget group"
         :class="{'--w-time':displayTime,
                  'actions-enabled':displayActions}">
      <div v-if="displayTime">
        <Time :date="transaction.date"
              :class="{'opacity-50':transaction.status === 0}"/>
      </div>
      <div class="flex items-center">
        <AccountIcon :icon="transaction.account.icon"
                     :icon-color="transaction.account.icon_color"
                     :icon-bg="transaction.account.icon_bg"
                     :class="{'opacity-50':transaction.status === 0}"/>
        <AccountName :name="transaction.account.title"
                     :class="{'opacity-50':transaction.status === 0}" class="truncate flex-1"/>
      </div>
      <div class="flex items-center">
        <Comment v-if="transaction.comment || !!transaction.transfer_id"
                 :class="{'opacity-50':transaction.status === 0}"
                 :transaction="transaction"
                 :comment="transaction.comment"
                 class="inline-block text-xs"/>
      </div>
      <div class="justify-self-end flex">
        <StatusPending v-if="transaction.status === 0"/>
        <Value :sum="transaction.sum"
               :sum-base="transaction.sum_base"
               class="md:pr-0"
               :class="{'line-through':transaction.off_budget,'opacity-50':transaction.status === 0}"
               :currency="transaction.account.currency"
               :currency-display="currencyDisplay"
               :isExpense="transaction.type === 2 || transaction.type === 4"
               :type="type"/>
      </div>
      <div v-if="displayActions">
        <Actions @remove="$emit('remove')"
                 @edit="$emit('edit')"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";
import Time from "@/components/common/Transaction/TransactionItem/Time";
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import Comment from "@/components/common/Transaction/TransactionItem/Comment";
import Actions from "@/components/common/Transaction/TransactionItem/Actions";
import StatusPending from "@/components/common/Transaction/TransactionItem/StatusPending";

export default {
  name: "TransactionViewBudget",
  components: {StatusPending, Actions, Comment, AccountName, AccountIcon, Time, Category, Value},
  mixins:[transactionCurrencyDisplayProp],
  props: {
    transaction: {
      type: Object,
      required: true
    },
    displayTime: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    type() {
      if (!!this.transaction.transfer_id) {
        return 'transfer'
      } else {
        return this.transaction.type === 1 ? 'income' : 'expense'
      }
    },
    transactionCategory() {
      if (this.transaction.type === 1) {
        return this.transaction.income;
      } else {
        return this.transaction.expense;
      }
    },
    displayActions() {
      // Скрываем иконку редактирования для инвестиционных переводов (типы 3 и 4),
      // так как они редактируются через интерфейс инвестиций
      return !this.currentUserIsWatcher && this.transaction.type !== 3 && this.transaction.type !== 4
    }
  }
}
</script>

<style scoped lang="scss">
.transaction-layout-budget-block {
  @apply relative;
  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.transaction-layout-budget {
  @apply flex py-4 items-center col-gap-6 relative;
  > div {
    transition: all .2s;
  }

  &.--w-time {
    > div {

      &:nth-of-type(1) {
        width: 3rem;
      }

      &:nth-of-type(2) {
        width: 26%;
        flex: none;
      }

      &:nth-of-type(3) {
        width: 0;
        flex: 1;
      }

      &:nth-of-type(4) {
        @apply -mr-6;
        width: auto;
      }

      &:nth-of-type(5) {
        width: 0;
        opacity: 0;
        overflow: hidden;
      }
    }
  }

  &:not(.--w-time) {
    > div {
      &:nth-of-type(1) {
        width: 26%;
      }

      &:nth-of-type(2) {
        width: auto;
        flex: 1;
      }

      &:nth-of-type(3) {
        @apply -mr-6;
        width: auto;
      }

      &:nth-of-type(4) {
        width: 0;
        opacity: 0;
        overflow: hidden;
      }
    }
  }

  &.actions-enabled {
    &.--w-time {
      &:hover {
        > div:nth-of-type(4) {
          @apply -mr-4;
        }

        > div:nth-of-type(5) {
          width: 15px;
          opacity: 1;
        }
      }
    }

    &:not(.--w-time) {
      &:hover {
        > div:nth-of-type(3) {
          @apply -mr-4;
        }

        > div:nth-of-type(4) {
          width: 15px;
          opacity: 1;
        }
      }
    }
  }
}

</style>